module.exports = __webpack_public_path__ + "assets/img/riskControl_b.d90a42bc.jpg";